@if (!displaySrc()) {
    <label
        class="dsf-zone"
        [style.width]="inputWidth()"
        [style.height]="inputHeight()"
    >
        <input
            type="file"
            accept="image/jpeg,image/jpg,image/png,image/gif"
            [id]="idInptut()"
            (change)="onImageSelected($event)"
        />
        @if (label()) {
            <span class="dsf-zone__label">{{ label() }}</span>
        } @else {
            <so-svg-icon-ui name="add_photo_alternate" [size]="22" color="--so-neuter" />
        }
    </label>
} @else {
    <div class="dsf-preview">
        <img
            class="dsf-preview__img"
            [src]="displaySrc()"
            [style.width]="imageWidth()"
            [style.height]="imageHeight()"
            [style.border-radius]="imageBorderRadius()"
            alt=""
        />

        <div class="dsf-preview__actions">
            <so-button-gradient-ui
                [text]="''"
                icon="edit"
                variant="gradient"
                color="primary"
                iconColor="--so-white"
                [height]="26"
                (click)="triggerFileInput()"
            />
            <so-button-gradient-ui
                [text]="''"
                icon="delete"
                variant="gradient"
                color="danger"
                iconColor="--so-white"
                [height]="26"
                (click)="confirmDelete() ? onRemoveClick() : clearImage()"
            />
        </div>

        <input
            type="file"
            accept="image/jpeg,image/jpg,image/png,image/gif"
            #changeInputRef
            [id]="idChangeInput()"
            (change)="onImageSelected($event)"
            hidden
        />
    </div>
}
